import { render, staticRenderFns } from "./msgBox.vue?vue&type=template&id=00f2c0fc&scoped=true&"
import script from "./msgBox.vue?vue&type=script&lang=js&"
export * from "./msgBox.vue?vue&type=script&lang=js&"
import style0 from "./msgBox.vue?vue&type=style&index=0&id=00f2c0fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2c0fc",
  null
  
)

export default component.exports